module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "302px",
      "height": "270px",
      "viewBox": "0 0 302 270",
      "id": "cord"
    }
  }, [_c('g', {
    attrs: {
      "id": "Module-6",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard-49",
      "transform": "translate(0.000000, -300.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000, 300.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.377166335,269.968717 C43.7747594,269.857602 77.3735909,255.449227 104.909894,227.883406 C116.382507,216.398494 126.732157,202.761098 137.046629,186.132572 C144.869603,173.520727 151.173203,161.972226 162.74876,139.695142 C163.196104,138.834231 164.751691,135.839247 164.767722,135.808386 C176.104384,113.985004 181.848207,103.410568 189.012115,91.737795 C198.214625,76.7433508 207.212293,64.6960015 216.92613,54.7744661 C239.378769,31.8417502 265.932496,20.1992188 301.234375,20.1992188 L301.234375,0.19921875 C260.441226,0.19921875 228.776128,14.0828401 202.635201,40.7827056 C191.758866,51.8915957 181.895023,65.0987016 171.966356,81.2763361 C164.474153,93.4840301 158.571756,104.350402 147.019561,126.588692 C147.002822,126.620914 145.448042,129.614346 145.001644,130.473435 C133.652095,152.315569 127.525364,163.540037 120.050767,175.590245 C110.486742,191.008932 101.035529,203.462489 90.7601841,213.748848 C66.9089482,237.625652 38.353096,249.871418 0.325958665,249.968783 L0.377166335,269.968717 Z",
      "id": "Path-2",
      "fill": "#EDEDED"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M260.486682,27.1843353 C272.451693,23.2026413 286.590352,20.1992188 301.234375,20.1992188 L301.234375,0.19921875 C283.524714,0.19921875 267.535432,2.81588774 252.971653,7.961891 C252.971653,13.191777 256.154297,24.4042969 260.486682,27.1843353 Z",
      "id": "Path-2",
      "fill": "#777777"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16f1a386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/cord.vue
// module id = 1000
// module chunks = 1